import { useEffect, useRef } from "react";

export function SkipMainLink() {
  return <a href="#main-content" onClick={(event) => {
    const main = document.getElementById("main-content");
    if (!main) return;
    event.preventDefault();
    main.focus();
    main.scrollIntoView({ block: "start", behavior: "auto" });
  }} className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-2 focus:z-[100] focus:min-h-[44px] focus:rounded-md focus:border focus:bg-background focus:px-4 focus:py-3 focus:text-foreground focus:shadow-lg">
    Перейти к основному содержимому
  </a>;
}

/** Focus a completed route transition, preserving autofocus and user input.
 * Search/hash updates, streaming and initial hydration never move focus. */
export function RouteFocus({ pathname, settled = true }: { pathname: string; settled?: boolean }) {
  const previous = useRef(pathname);
  useEffect(() => {
    if (!settled || previous.current === pathname) return;
    previous.current = pathname;
    const origin = document.activeElement;
    let observer: MutationObserver | null = null;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const attempt = () => {
      const current = document.activeElement;
      // A newly focused field/dialog belongs to the user or the destination's
      // autofocus. Do not steal it after an asynchronous auth/lazy load.
      if (current !== origin && current !== document.body) return true;
      const main = document.getElementById("main-content");
      if (!main) return false;
      main.focus({ preventScroll: true });
      return true;
    };
    const frame = requestAnimationFrame(() => {
      if (attempt()) return;
      observer = new MutationObserver(() => {
        if (attempt()) { observer?.disconnect(); clearTimeout(timer); }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      timer = setTimeout(() => observer?.disconnect(), 2000);
    });
    return () => { cancelAnimationFrame(frame); observer?.disconnect(); clearTimeout(timer); };
  }, [pathname, settled]);
  return null;
}
